/**
 * vuex 메인 상태
 * @name store/modules/main
 * @type {State}
 * @property {Boolean} is 메인 페이지 인지 유무
 * @property {Boolean} showTopBanner 티배너 숨김 유무
 */
const state = () => ({
  is           : false,
  showTopBanner: true
});

const getters = {};

const mutations = {
  /**
   * 메인 페이지 인지 유무
   * @param {*} state
   * @param {boolean} value
   */
  SET_IS: (state, value) => {
    state.is = value;
  },
  /**
   * 티배너 숨김 유무
   * @param {*} state
   * @param {boolean} value
   */
  SET_SHOW_TOP_BANNER: (state, value) => {
    state.showTopBanner = value;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
